import React from "react";

import { InfoToolTip } from "aible";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleUp, faArrowAltCircleDown } from "@fortawesome/free-solid-svg-icons";

import styles from "./style.module.css";

export default class PredictionDriverToolTip extends React.PureComponent {
  render() {
    return (
      <InfoToolTip
        style={{ marginLeft: "6px" }}
        placement={"bottom"}
        title={"Model Driver Explanation"}
        {...this.props}
      >
        <div style={{ width: "275px" }}>
          <div className={styles.botDelta} style={{ marginBottom: "10px" }}>
            {"The model drivers are listed by field in order of impact with the strongest field first."}
          </div>
          <div className={styles.driverItem}>
            <span className={styles.botDelta + " " + styles.increase}>
              <FontAwesomeIcon style={{ marginRight: "10px" }} icon={faArrowAltCircleUp} />
            </span>
            <div>
              <div>{"Strongest Positive Impact Value"}</div>
            </div>
          </div>
          <div className={styles.driverItem}>
            <span className={styles.botDelta + " " + styles.decrease}>
              <FontAwesomeIcon style={{ marginRight: "10px" }} icon={faArrowAltCircleDown} />
            </span>
            <div>
              <div>{"Strongest Negative Impact Value"}</div>
            </div>
          </div>
        </div>
      </InfoToolTip>
    );
  }
}
